import axiosInstance from "../../../api/axiosInstance";
import { endpoints } from "../../../services/endpoints";
import {
    verifyAdminLoginOtpRequest,
    verifyAdminLoginOtpRequestError,
    verifyAdminLoginOtpRequestSuccess,
} from "../../slices/auth/VerifyAdminLoginOtpSlice";

export const VerifyAdminLoginOtpAPI = (data) => {
    return async (dispatch) => {
        try {
            dispatch(verifyAdminLoginOtpRequest());
            const response = await axiosInstance({
                method: "POST",
                url: endpoints.verifyAdminLoginOtp,
                data: data,
                headers: { "Content-Type": "application/json" },
            });
            return dispatch(verifyAdminLoginOtpRequestSuccess(response?.data));
        } catch (error) {
            const _error = {
                data: error?.response?.data?.message || error?.message,
                status: error?.response?.status || error?.status,
            };
            return dispatch(verifyAdminLoginOtpRequestError(_error));
        }
    };
};